<template>
    <div class="flex flex-col h-full gap-2">
        <pca-grid-ro
            ref="gridRef"
            :showToolbar="true"
            :show-grid-footer="false"
            :meta="gridMeta"
            :toolbar-user-items="toolbarUserItems"
            @toolbar-button-click="toolbarButtonClick"
        />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import PcaGridRo from '@/views/contracts/print-contract/components/pca-grid-ro.vue';
import { getDownload } from '@/service/http';

const gridRef = ref();

const emit = defineEmits(['toolbarButtonClick']);

onMounted(() => {});

const toolbarButtonClick = async e => {
    switch (e.item.component.name) {
        case 'downloadFiles':
            await onDownloadFilesClick(e);
            break;
        case 'exportToPdf':
            await onExportToPdfClick(e);
            break;
        case 'printOneFile':
            await onPrintOneFileClick(e);
            break;
        case 'clearAll':
            await onClearAllClick(e);
            break;

        default:
            break;
    }
    emit('toolbarButtonClick', e);
};

const onDownloadFilesClick = async () => {
    const selectedRowsData = gridRef.value.gridInstance.getSelectedRowsData();

    for (let ix = 0; ix < selectedRowsData.length; ix++) {
        await getDownload({
            storage: selectedRowsData[ix].stor,
            fileName: selectedRowsData[ix].fn,
        });
    }
};

const onExportToPdfClick = async () => {
    console.log('Нажатие на кнопку Экспорт в pdf выделенных файлов');
};

const onPrintOneFileClick = async () => {
    console.log('Нажатие на кнопку Напечатать все докуметы каждого договора одним файлом');
};

const onClearAllClick = async () => {
    console.log('Нажатие на кнопку Очистить всё');
};

const gridMeta = {
    keyExpr: 'stor',
    scrollingMode: 'standart',
    maxWidth: 'max-w-96',
    showCheckBoxesMode: 'none',
    wordWrapEnabled: true,
    autoLoadData: false,
    showToolbar: true,
    showFilterPanel: false,
    selectionMode: 'multiple',
    columns: [
        {
            dataField: 'contractID',
            caption: 'Код договора',
            visible: false,
        },
        {
            dataField: 'tmplID',
            caption: 'Код шаблона',
            visible: false,
        },
        {
            dataField: 'docID',
            caption: 'Код документа',
            visible: false,
        },
        {
            dataField: 'fn',
            caption: 'Название файла',
            visible: true,
        },
        {
            dataField: 'stor',
            caption: 'Путь в файловом хранилище',
            visible: true,
        },
    ],
    api: {
        select: 'mped./mped/calculation-string-algorithm-grid-select/get',
    },
};

const toolbarUserItems = [
    {
        widget: 'dx-button',
        index: 0,
        component: {
            name: 'downloadFiles',
            hint: 'Скачать файлы',
            emits: [{ name: 'click' }],
            htmlElement: 'ai-export-pdf-selected-base',
        },
    },
    {
        widget: 'dx-button',
        index: 1,
        component: {
            name: 'exportToPdf',
            hint: 'Экспорт в pdf выделенных файлов',
            emits: [{ name: 'click' }],
            htmlElement: 'ai-export-pdf-selected-base',
        },
    },
    {
        widget: 'dx-button',
        index: 2,
        component: {
            name: 'printOneFile',
            hint: 'Напечатать все докуметы каждого договора одним файлом',
            emits: [{ name: 'click' }],
            htmlElement: 'ai-copy-base',
        },
    },
    {
        widget: 'dx-button',
        index: 3,
        component: {
            name: 'clearAll',
            hint: 'Очистить всё',
            emits: [{ name: 'click' }],
            htmlElement: 'ai-copy-base',
        },
    },
];

const setPrintResult = async data => {
    gridRef.value.setDataSource(null, null, data);
};

defineExpose({
    setPrintResult,
});
</script>
